export default "__VITE_ASSET__DS$4MUOn__"